import { useState } from "react";
import { Link } from "react-router-dom";
import { FileDown, LayoutTemplate, Search } from "lucide-react";
import { API } from "../../lib/api";
import { templateHref } from "../../lib/productTemplates";
import { TEMPLATE_LIBRARY } from "../../lib/templateLibrary";
import { trackTool } from "../../lib/track";
import { Panel, field } from "./_ui";

export function TemplateLibrary() {
  const [q, setQ] = useState("");
  const needle = q.trim().toLowerCase();
  const groups = TEMPLATE_LIBRARY.map((g) => ({ ...g, items: g.items.filter((t) => !needle || t.label.toLowerCase().includes(needle) || g.group.toLowerCase().includes(needle)) })).filter((g) => g.items.length);
  const total = TEMPLATE_LIBRARY.reduce((s, g) => s + g.items.length, 0);

  return (
    <Panel icon={LayoutTemplate} title={`Free print template library — ${total} die-lines`} testId="template-library">
      <div className="relative mb-4 max-w-md">
        <Search className="w-4 h-4 absolute left-2.5 top-2.5 text-white/40" />
        <input value={q} onChange={(e) => setQ(e.target.value)} className={`${field} pl-8`} placeholder="Search: business card, 4x6, banner, label…" data-testid="template-search" />
      </div>
      <p className="text-xs text-white/60 mb-4">Every template is a vector PDF with trim, bleed and safe-zone guides at exact size — open it in Illustrator, InDesign, Affinity or Canva (import as PDF), design on top, hide the guide layer, export. Need a size that isn't here? Type any dimensions on a product page's Templates tab.</p>
      <div className="grid md:grid-cols-2 gap-4" data-testid="template-groups">
        {groups.map((g) => (
          <div key={g.group} className="bg-black/25 border border-white/10 rounded-sm">
            <div className="flex items-center justify-between px-3 py-2 border-b border-white/10">
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#E8B587] font-bold">{g.group}</div>
              <Link to={g.shop} className="font-mono text-[10px] tracking-widest uppercase text-white/60 hover:text-white">Shop →</Link>
            </div>
            <ul className="divide-y divide-white/5">
              {g.items.map((t) => (
                <li key={t.label} className="flex items-center justify-between gap-3 px-3 py-1.5 text-sm">
                  <span>{t.label}<span className="text-white/40 text-xs ml-2">{t.bleed ? `${t.bleed}" bleed` : "no bleed"}</span></span>
                  <a href={templateHref(API, null, { w: t.w, h: t.h, bleed: t.bleed, label: `Kolt Printing · ${t.label}` })} target="_blank" rel="noreferrer" onClick={() => trackTool("template-library", "download", { label: t.label })} className="inline-flex items-center gap-1 font-mono text-[10px] tracking-widest uppercase text-white hover:text-[#E8B587] whitespace-nowrap" data-testid={`template-dl-${t.w}x${t.h}`}>
                    <FileDown className="w-3.5 h-3.5" /> PDF
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
        {groups.length === 0 && <div className="text-sm text-white/70">No template matches "{q}". Try a product name or a size like 4x6.</div>}
      </div>
    </Panel>
  );
}
